import { FC, MouseEventHandler, ReactNode, useCallback, useEffect, useRef } from "react";
import F7 from "../../../utils/F7";
import { useNavigate } from "react-router-dom";

const ListBlockItem: FC<{
  title: ReactNode;
  to?: string;
  styleIcon?: ReactNode;
  media?: ReactNode;
  after?: ReactNode;
  onClick?: () => void;
  onSort?: (e: Event) => void;
  sortKey?: string;
  children?: ReactNode;
}> = (props) => {
  const ref = useRef<HTMLLIElement>(null);

  useEffect(() => {
    const onSort = props.onSort;
    const li = ref.current;
    if (onSort && li) {
      li.addEventListener("sort", onSort);
      return () => li.removeEventListener("sort", onSort);
    }
  }, [props.onSort]);

  const navigate = useNavigate();
  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      if (props.onClick) {
        props.onClick();
      } else if (props.to) {
        e.preventDefault();
        let to: string = props.to;
        Promise.resolve(() => F7.closePanel()).then(() => {
          navigate(to);
        });
      }
    },
    [props, navigate]
  );

  return (
    <li ref={ref}>
      <button
        onClick={handleClick}
        className="item-link item-content"
        style={{
          background: "none",
          border: "none",
          padding: 0,
          width: "100%",
        }}
      >
        {props.styleIcon ? <div className="item-media">{props.styleIcon}</div> : null}
        {props.media ? <div className="item-media">{props.media}</div> : null}
        <div className="item-inner" style={{ padding: 8 }}>
          <div className="item-title">{props.title}</div>
          <div className="item-after" style={{ marginRight: 30 }}>
            <small>{props.after}</small>
          </div>
        </div>
      </button>
      {props.children}
      <div className="sortable-handler" data-sort={props.sortKey}></div>
    </li>
  );
};

export default ListBlockItem;
